import { Auth } from 'aws-amplify';
import AmplifyWrapper from '../service/auth.service';

export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';

const requestLogin = (username, password) => {
	return {
		type: LOGIN
	};
};

const recieveLoginSuccess = user => {
	return {
		type: LOGIN_SUCCESS,
		user
	};
};

const recieveLoginError = errors => {
	return {
		type: LOGIN_ERROR,
		errors
	};
};

export const login = (username, password) => {
	return async function(dispatch) {
		//
		dispatch(requestLogin(username, password));

		try {
			const user = await Auth.signIn(username, password);

			// If MFA is enabled, sign-in should be confirmed with the confirmation code
			if (user.challengeName === 'SMS_MFA' || user.challengeName === 'SOFTWARE_TOKEN_MFA') {
				let code = prompt('Please enter your code. (MFA method: ' + user.challengeName + ')', '');
				/* const loggedUser =  */ await AmplifyWrapper.confirmSignIn(
					user, // Return object from Auth.signIn()
					code, // Confirmation code
					user.challengeName // MFA Type e.g. SMS_MFA, SOFTWARE_TOKEN_MFA
				)
					.then(userData => {
						dispatch(recieveLoginSuccess(userData));
					})
					.catch(err => {
						dispatch(recieveLoginError(err));
					});
			} else if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
				return alert('NEW_PASSWORD_REQUIRED: Unsupported flow. Please contact your administrator');

				//const { requiredAttributes } = user.challengeParam; // the array of required attributes, e.g ['email', 'phone_number']

				let newPassword = prompt('Please enter your new password', '');

				/* const loggedUser =  */ await Auth.completeNewPassword(
					user, // the Cognito User Object
					newPassword // the new password
					// OPTIONAL, the required attributes
					/* 
                        {
							email,
							phone_number
                        } 
                    */
				);
			} else if (user.challengeName === 'MFA_SETUP') {
				// This happens when the MFA method is TOTP. The user needs to setup the TOTP before using it.
				return alert('MFA_SETUP: Unsupported flow. Please contact your administrator');
				//Auth.setupTOTP(user);
			} else {
				dispatch(recieveLoginSuccess(user));
			}
		} catch (err) {
			console.log(err);

			if (err.code === 'UserNotConfirmedException') {
				// The error happens if the user didn't finish the confirmation step when signing up
				// In this case you need to resend the code and confirm the user
				// About how to resend the code and confirm the user, please check the signUp part
			} else if (err.code === 'PasswordResetRequiredException') {
				// The error happens when the password is reset in the Cognito console
				// In this case you need to call forgotPassword to reset the password
				// Please check the Forgot Password part.
			} else if (err.code === 'NotAuthorizedException') {
				// The error happens when the incorrect password is provided
			} else if (err.code === 'UserNotFoundException') {
				// The error happens when the supplied username/email does not exist in the Cognito user pool
			} else {
				//console.log(err);
			}

			dispatch(recieveLoginError(err));
		}
	};
};
